import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'GLOBAL_SETTINGS',
  entryPoint: '/global-settings',
  collectionName: 'settings',
});

export default triggers;



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/global/triggers.js